export default __webpack_public_path__ + "static/media/tell-us-icon.13f5b724.svg";